import { render, staticRenderFns } from "./HabitNew.vue?vue&type=template&id=b65b5f60&"
import script from "./HabitNew.vue?vue&type=script&lang=js&"
export * from "./HabitNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports